import { FunctionComponent } from 'react'
import { observer } from 'mobx-react-lite'
import { makeStyles, mergeClasses } from '@griffel/react'
import { tokens } from '@fluentui/tokens'

const useClasses = makeStyles({
  root: {
    padding: tokens.spacingHorizontalS,
    boxShadow: tokens.shadow8
  }
})

/** Wrap this around each list item panel. */
export const ListItemPanel: FunctionComponent<{ children?: React.ReactNode, className?: string }> = observer(({ children, className }) => {
  const classes = useClasses()

  return (
    <div className={mergeClasses(classes.root, className)}>
      {children}
    </div>
  )
})